import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { EVENT_LOCATION_TYPE } from '#/utils/constants/general/eventLocationType';
import { LOCATION_TYPE } from '#/utils/constants/general/locationType';

export function locationTypeFacet(i18n: I18nFn) {
  return {
    id: 'locationTypeFacet',
    name: 'locationType',
    get title() {
      return i18n('Location');
    },
    type: 'array',
    options: Object.keys(LOCATION_TYPE(i18n)),
    optionTitles: LOCATION_TYPE(i18n),
  } as const satisfies SearchFacetData;
}

export function eventLocationTypeFacet(i18n: I18nFn) {
  return {
    id: 'locationTypeFacet',
    name: 'locationType',
    get title() {
      return i18n('Location');
    },
    type: 'array',
    options: Object.keys(LOCATION_TYPE(i18n)),
    optionTitles: EVENT_LOCATION_TYPE(i18n),
  } as const satisfies SearchFacetData;
}
